import { Helmet } from '@dr.pogodin/react-helmet';
import { Whitelabels } from 'src/constants';

type Props = {
  /** Put ahead of every title, for something the tab should show at a glance. */
  prefix?: string;
};

/**
 * How every page title is built: the page's own title, then the brand.  Pages
 * set only their own part, through a Helmet title.
 *
 * Rendered once at the root.  Helmet takes the innermost template, so another
 * one further down the tree replaces it for as long as that one is mounted.
 */
export default function PageTitleTemplate({ prefix = '' }: Props) {
  const { name } = Whitelabels.getWhitelabel();

  return (
    <Helmet
      titleTemplate={`${prefix}%s | ${name}`}
      defaultTitle={`${prefix}${name}`}
    />
  );
}
